import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  container: { padding: theme.spacing(2), gap: theme.spacing(2) },
  title: {
    fontWeight: 500,
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: theme.accent.main,
    paddingBottom: theme.spacing(2)
  },
  actionsContainer: {
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  },
  content: { padding: 0 },
  touchTargets: {
    '@media (hover: none) and (pointer: coarse)': { '& .MuiButton-root': { minHeight: 44 } }
  },
  removeCell: {
    [theme.breakpoints.down('md')]: {
      '& .MuiButton-root': {
        width: '100%',
        minWidth: 0,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
      }
    },
    '@media (hover: none) and (pointer: coarse)': { '& .MuiButton-root': { minHeight: 44 } }
  },
  actionButtons: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: { paddingBottom: `calc(${theme.spacing(2)} + env(safe-area-inset-bottom, 0px))` }
  }
}));
